var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitIconNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43214"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 108",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D8E4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 10.8887V13.9998L16.3333 16.3331",
    stroke: "#235594",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z",
    stroke: "#235594",
    strokeWidth: 1.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitIconNode);
export default __webpack_public_path__ + "static/media/waitIconNode.a16deccde13ae6f6d6219dc72c398729.svg";
export { ForwardRef as ReactComponent };